"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../../types");
const getWidth = ({ theme, size }) => ({
    [types_1.toastSizes.small]: theme.toastSmall,
    [types_1.toastSizes.medium]: theme.toastMedium,
    [types_1.toastSizes.large]: theme.toastLarge,
}[size]);
exports.default = getWidth;
